import { FeaturedPerksTile } from "./tiles/FeaturedPerksTile";
import { OffersTile } from "./tiles/OffersTile";
import { GetHypercardTile } from "./tiles/GetHypercardTile";
import { PointsPromoTile } from "./tiles/PointsPromoTile";
import { LastTransactionsPromoTile } from "./tiles/LastTransactionsPromoTile";

export const NonCardholderHomePage = () => {
  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 xl:grid-cols-3">
      <div className="col-span-full min-h-[280px] lg:col-span-2">
        <GetHypercardTile />
      </div>
      <PointsPromoTile />
      <LastTransactionsPromoTile />
      <FeaturedPerksTile />
      <OffersTile />
    </div>
  );
};
